
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/b1b2f0b21fd94ab4a00dfc9a5951f0a8/05ef9632faa424de10622c99cf932b61.jpeg"
              alt="Rastrek Logo"
              className="h-12 w-auto object-contain"
            />
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('beneficios')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Benefícios
            </button>
            <button
              onClick={() => scrollToSection('provas-sociais')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Depoimentos
            </button>
            <button
              onClick={() => scrollToSection('qualidades')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Qualidades
            </button>
            <button
              onClick={() => scrollToSection('instalacao')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Instalação
            </button>
            <a
              href="https://wa.me/5511954662476"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-500 text-black px-6 py-2.5 rounded-lg font-semibold hover:bg-yellow-400 transition-all whitespace-nowrap cursor-pointer text-sm"
            >
              Falar no WhatsApp
            </a>
          </div>

          <button
            onClick={() => scrollToSection('contato')}
            className="md:hidden bg-yellow-500 text-black px-5 py-2 rounded-lg font-semibold hover:bg-yellow-400 transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            Contato
          </button>
        </div>
      </div>
    </nav>
  );
}
